import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';
import { UploadPhotoToken } from '../types';

const featureSelector = createFeatureSelector('reviews');

export const getSelectedPhotos = createSelector(featureSelector, (f) => f.selectedPhotos);
const getUploadCache = createSelector(featureSelector, (f) => f.photosFileCache);
export const getUploadCacheByToken = (uploadToken: UploadPhotoToken) =>
  createSelector(getUploadCache, (cache) => cache.find((r) => r.uploadToken === uploadToken));
